import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(Router);

const router = new Router({
    routes,
});

// 进入路由前
router.beforeEach((to, from, next)=> {
    // 导航激活状态
	store.dispatch('changeNavName', to.name);
	// 面包导航条
	store.dispatch('changeCrumb', {
		txt: to.meta.crumb,
		index: 0,
		cutOut: false,
	});

    if(to.fullPath != "/login" && !store.getters.isLogin){
        console.log(123);
        next('/login');
    }else {
        next();
    }
});


export default router;